import React from 'react';
import {
    AssignmentTurnedInOutlined,
    ChatBubbleOutline,
    CheckCircleOutline,
    GroupAddOutlined,
    HighlightOff,
    LocalOfferOutlined,
    LocalShippingOutlined,
    NotificationsNoneOutlined,
    PublishOutlined,
    SwapHorizOutlined,
    UndoOutlined,
    UploadFileOutlined
} from '@mui/icons-material';
import { Box } from '@mui/material';

import { NotificationType } from '../../types';
import {
    COLOR_OUTLINE,
    COLOR_TEAL,
    COLOR_WHITE
} from '../../theme';

function matchIcon(message: string): React.ReactElement {
    if (message.includes('Publicerade frakt')) {
        return <PublishOutlined fontSize="small" />;
    }
    if (message.includes('sparad som utkast') || message.includes('Logtrade-frakt')) {
        return <PublishOutlined fontSize="small" />;
    }
    if (message.includes('nytt prisförslag') || message.includes('lämnat ett nytt prisförslag')) {
        return <LocalOfferOutlined fontSize="small" />;
    }
    if (message.includes('nytt meddelande') || message.includes('skickat ett nytt meddelande')) {
        return <ChatBubbleOutline fontSize="small" />;
    }
    if (message.includes('accepterat ert prisförslag')) {
        return <CheckCircleOutline fontSize="small" />;
    }
    if (message.includes('avböjt ert prisförslag') || message.includes('har avböjts')) {
        return <HighlightOff fontSize="small" />;
    }
    if (message.includes('dragit tillbaka') || message.includes('dragits tillbaka')) {
        return <UndoOutlined fontSize="small" />;
    }
    if (message.includes('har laddat upp')) {
        return <UploadFileOutlined fontSize="small" />;
    }
    if (message.includes('bekräftat uppdrag')) {
        return <AssignmentTurnedInOutlined fontSize="small" />;
    }
    if (message.includes('utfört uppdrag')) {
        return <LocalShippingOutlined fontSize="small" />;
    }
    if (message.includes('bjudit in er till gruppen')) {
        return <GroupAddOutlined fontSize="small" />;
    }
    if (message.includes('uppdragsförslag')) {
        return <LocalShippingOutlined fontSize="small" />;
    }
    if (message.includes('transportförfrågan')) {
        return <LocalShippingOutlined fontSize="small" />;
    }
    if (message.includes('tilldelat någon annan') || message.includes('tilldelats någon annan')) {
        return <SwapHorizOutlined fontSize="small" />;
    }
    if (message.includes('publicerades')) {
        return <PublishOutlined fontSize="small" />;
    }
    return <NotificationsNoneOutlined fontSize="small" />;
}

type PropsType = {
    notification: NotificationType
};

export default function NotificationEventIcon({ notification }: PropsType) {
    return (
        <Box
            sx={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: COLOR_WHITE,
                border: `1px solid ${COLOR_OUTLINE}`,
                color: COLOR_TEAL,
                flexShrink: 0,
                zIndex: 1
            }}
        >
            {matchIcon(notification.message)}
        </Box>
    );
}
